// components/Books/BookCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import styles from "./BookCard.module.css";

export default function BookCard({ book }) {
  const slug = String(book.slug || "").trim();

  // Patrones numéricos por colección
  const mSol = slug.match(/^solidity-(\d+)$/);                    // p.ej. "solidity-2"
  const mBc  = slug.match(/^blockchain-fundamentos-(\d+)$/);      // p.ej. "blockchain-fundamentos-3"

  let href = "/"; // fallback seguro

  if (mSol) {
    // Colección: Solidity
    const id = mSol[1];
    href = `/course/solidity-book/${id}`;
  } else if (mBc) {
    // Colección: Fundamentos de Blockchain
    const id = mBc[1];
    href = `/course/blockchain-fundamentos/${id}`;
  } else if (slug === "fundamentos-de-blockchain") {
    // Portada/landing del libro → envía al capítulo 1 por defecto
    href = `/course/blockchain-fundamentos/1`;
  } else if (slug === "solidity-book") {
    href = `/course/solidity-book/1`;
  } else if (book.basePath) {
    // Si en tus datos incluyes basePath (recomendado)
    href = `${book.basePath.replace(/\/$/, "")}/1`;
  } else {
    // Último recurso: envía a una ruta genérica por slug
    href = `/course/${slug}`;
  }

  return (
    <article className={styles.card}>
      <div className={styles.hero}>
        <img src={book.cover} alt={book.title} className={styles.cover} />
      </div>

      <div className={styles.body}>
        <h3 className={styles.title}>{book.title}</h3>
        {book.subtitle && <p className={styles.subtitle}>{book.subtitle}</p>}
        <p className={styles.desc}>{book.description}</p>
      </div>

      <div className={styles.footer}>
        <Link to={href} className={styles.button}>
          Ver Libro
        </Link>
      </div>
    </article>
  );
}
